'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DatabaseFieldCell;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RequiredAsterisk = require('../../RequiredAsterisk');

var _RequiredAsterisk2 = _interopRequireDefault(_RequiredAsterisk);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function DatabaseFieldCell(props) {
  var value = props.value,
      required = props.row.required;
  return _react2["default"].createElement('span', null, _react2["default"].createElement(_RequiredAsterisk2["default"], {
    required: !!required
  }), value);
}

DatabaseFieldCell.propTypes = {
  value: _propTypes2["default"].string.isRequired,
  row: _propTypes2["default"].object.isRequired
};